import React, { useEffect } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useAuth } from 'auth/AuthContext';
import { setOnUnauthorized } from '../api/interceptors';
import HomeScreen from '../screens/HomeScreen';
import QRCodeScreen from '../screens/QRCodeScreen';

export type DashboardStackParamList = {
  Home: undefined;
  QRCode: undefined;
};

const Stack = createNativeStackNavigator<DashboardStackParamList>();

const MainNavigator = () => {
  const { signOut } = useAuth();

  useEffect(() => {
    setOnUnauthorized(() => {
      signOut();
    });
  }, [signOut]);

  return (
    <Stack.Navigator
      screenOptions={{
        headerStyle: { backgroundColor: '#000000' },
        headerTintColor: '#FFDD00',
        headerTitleStyle: { fontWeight: '600' },
      }}
    >
      <Stack.Screen name="Home" component={HomeScreen} options={{ title: 'Dashboard' }} />
      <Stack.Screen name="QRCode" component={QRCodeScreen} options={{ title: 'Your QR Code' }} />
    </Stack.Navigator>
  );
};

export default MainNavigator;
